export enum OwnershipConnectionsContextActionTypes {
  SetCompanyId = 'connection/SET_COMPANY_ID',
  SetOnlyBeneficialOwnership = 'connection/SET_ONLY_BENEFICIAL',
  SetIncludeHistoricalOwnership = 'connection/SET_INCLUDE_HISTORICAL',
  SetShowAllConnections = 'connection/SET_SHOW_ALL_CONNECTIONS',
  NavigateToPath = 'connection/NAVIGATE_PATH',
  PushToPath = 'connection/PUSH_PATH',
}
export interface Path {
  id: string;
  name: string;
}

export type OwnershipConnectionsContextActions =
  | { type: OwnershipConnectionsContextActionTypes.SetCompanyId; payload: string }
  | { type: OwnershipConnectionsContextActionTypes.SetOnlyBeneficialOwnership; payload: boolean }
  | { type: OwnershipConnectionsContextActionTypes.SetIncludeHistoricalOwnership; payload: boolean }
  | { type: OwnershipConnectionsContextActionTypes.SetShowAllConnections; payload: boolean }
  | { type: OwnershipConnectionsContextActionTypes.PushToPath; payload: Path }
  | { type: OwnershipConnectionsContextActionTypes.NavigateToPath; payload: number };

export type OwnershipConnectionsProps = {
  companyId: string;
  onlyBeneficialOwnership: boolean;
  includeHistoricalOwnership: boolean;
  showAllConnections: boolean;
  path: Path[];
};

export type OwnershipConnectionsProviderProps = { children: React.ReactNode };
